/**
 * @module project/components/participate_form/info_form_name
 */
import React, { PropTypes, Component } from 'react';
import { TextInputField, TextAreaField, CheckBoxField } from 'common/components/form_fields';

/**
 * Participate info step form for name entries
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const InfoFormName = (props) => {
  const { entry, updateName, updateDescription, updateDomainAvailable, isTagline } = props;

  return (
    <div className="participate-content">
      <fieldset>
        <h3>Proposed { isTagline? 'Tagline' : 'Name' }</h3>
        <TextInputField meta={{}} input={{
          value: entry.name,
          name: "entry_name",
          onChange: updateName
        }}/>
      </fieldset>

      <fieldset>
        <h3>Add a description</h3>
        <p>
          The description helps the client understand why your
          proposed { isTagline? 'tagline' : 'name' } is great.
          Entries with meaningful descriptions win 30% more than those without.
          Your description must be at least 100 characters.
        </p>
        <TextAreaField meta={{}} rows={4} minCharCount={100}
          input={{
                   value: entry.description,
                   name: "entry_description",
                   onChange: updateDescription
                 }}/>
      </fieldset>

      { !isTagline &&
      <fieldset>
        <h3>URL</h3>
        <CheckBoxField meta={{}} label="An exact domain is available for this name"
          input={{
                   value: entry.domain_available,
                   name: "entry_description",
                   onChange: (val) => updateDomainAvailable({target: {value: val}})
                 }}/>
      </fieldset> }
    </div>
  );
};

/**
 * PropTypes.
 *
 * @property {object} entry - local entry data object
 * @property {bool} isTagline - whether project is a tagline one
 * @property {func} updateName - update local entry name
 * @property {func} updateDescription - update local entry description
 * @property {func} updateDomainAvailable - update local entry "domain available" flag
 */
InfoFormName.propTypes = {
  isTagline: PropTypes.bool,
  entry: PropTypes.object,
  updateName: PropTypes.func,
  updateDescription: PropTypes.func,
  updateDomainAvailable: PropTypes.func
};

export default InfoFormName;



// WEBPACK FOOTER //
// ./project/components/participate_form/info_form_name.jsx